@if (data) {
<div id="pagination" class="flex items-center gap-3">
    <button [disabled]="!data?.prev_page" class="btn btn-sm " (click)="changePage(data?.prev_page)"><i class="ri-arrow-left-s-line"></i> Prev</button>
    <div class="flex items-center gap-1">
        @for (i of data.pages; track $index) {
            <button class="btn btn-sm btn-square"
            (click)="changePage(i)"
            [disabled]="i == data?.current_page"
            [ngClass]="{'page-active': i == data?.current_page}"
            >{{i}}</button>
        }
    </div>
    <button class="btn btn-sm " [disabled]="!data?.next_page" (click)="changePage(data?.next_page)">Next <i class="ri-arrow-right-s-line"></i></button>
</div>
}